/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CommunicationContentStateEnum = {
    Ready: 'READY',
    Pending: 'PENDING',
    Unavailable: 'UNAVAILABLE',
    Archiving: 'ARCHIVING',
    Failed: 'FAILED'
} as const;
export type CommunicationContentStateEnum = typeof CommunicationContentStateEnum[keyof typeof CommunicationContentStateEnum];

